export default "__VITE_ASSET__gJgL5sye__"